module.exports = __webpack_public_path__ + "static/trade-7-7032c553e66bd27395bc8d194b06ed44.svg";